import React, { useState, useEffect } from 'react';
import './FullScreenLoader.css';

const TIPS = [
  'Optimizando consultas SQL para máximo rendimiento...',
  'Cargando millones de registros de ventas...',
  'Sincronizando data warehouse con GitHub...',
  'Construyendo índices para filtros ultra-rápidos...',
  'Preparando dashboards interactivos...',
  'Aplicando caché inteligente para próxima visita...'
];

const FullScreenLoader = ({ message = 'Iniciando Dimassi Sales...', progress = 0 }) => {
  const [currentTipIndex, setCurrentTipIndex] = useState(0);
  const progressPercent = Math.min(Math.max(progress, 0), 100);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTipIndex((prev) => (prev + 1) % TIPS.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fullscreen-loader-overlay">
      <div className="loader-content">
        {/* Enhanced Spinner */}
        <div className="loader-spinner-dual">
          <div className="spinner-ring outer"></div>
          <div className="spinner-ring inner"></div>
        </div>

        {/* Main Message */}
        <h2 className="loader-main-message">{message}</h2>

        {/* Progress Bar */}
        {progressPercent !== null && (
          <div className="progress-container">
            <div className="progress-bar-bg">
              <div 
                className="progress-bar-fill" 
                style={{ width: `${progressPercent}%` }}
              >
                <span className="progress-text">{Math.round(progressPercent)}%</span>
              </div>
            </div>
          </div>
        )}

        {/* Rotating Tips */}
        <p className="loader-tip fade-in-out">{TIPS[currentTipIndex]}</p>

        {/* Status dots */}
        <div className="status-dots">
          <div className="dot active"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
